module.exports = __webpack_public_path__ + "img/banner-two9.bfafc8a3.png";